import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Employer, EmployerUser } from '../../models/employer.model';
import { EmployerInterface } from './employer.interface';
import { InquiryRequestDTO } from 'src/app/models/inquiry-request.model';
import { EmployerSearchAddWorkerResponse, EmployerSearchAddWorker } from 'src/app/models/employer-search-add-worker.model';


@Injectable({ providedIn: 'root' })
export class EmployerService implements EmployerInterface {

  constructor(private httpClient: HttpClient) { }

  CreateEmployer(employer: Employer): Observable<any> {
    return this.httpClient.post<any>(environment.apiBaseUrl + 'employer/create', employer);
  }

  SubmitInquiryRequest(request: InquiryRequestDTO): Observable<boolean> {
    return this.httpClient.post<boolean>(environment.apiBaseUrl + `employer/SubmitInquiryRequest`, request);
  }

  GetEmployerTeam(): Observable<EmployerUser[]> {
    return this.httpClient.get<any>(`${environment.apiBaseUrl}employer/GetAllTeamMembers`);
  }

  FindAndAddWorkerToEmployer(employerWorkerSearch: EmployerSearchAddWorker): Observable<EmployerSearchAddWorkerResponse> {
    return this.httpClient.post<EmployerSearchAddWorkerResponse>(environment.apiBaseUrl + 'employer/FindAndAddWorkerToEmployer', employerWorkerSearch);
  }

  SaveEmployerTeamMember(employer: EmployerUser): Observable<any> {
    return this.httpClient.post<any>(environment.apiBaseUrl + 'employer/SaveEmployerTeamMember', employer);
  }

  DoesEmployerMemberEmailExist(email: string): Observable<boolean> {
    return this.httpClient.post<boolean>(environment.apiBaseUrl + `employer/DoesEmployerMemberEmailExist`, { 'email': email }, { reportProgress: true });
  }

  GetTeamMemberInfo(employerUserId: string): Observable<EmployerUser> {
    return this.httpClient.get<any>(`${environment.apiBaseUrl}employer/GetTeamMemberInfoByEmployerUserId/${employerUserId}`);
  }

  DeleteTeamMember(employerUserId: string) {
    return this.httpClient.delete<boolean>(environment.apiBaseUrl + `employer/DeleteTeamMember/${employerUserId}`)
  }

}
